// src/App.jsx
import React from "react";
import { HashRouter } from "react-router-dom";
import Routes from "./Routes";
import "./App.css";
import "./index.css";

function App() {
  return (
    <HashRouter>
      <Routes />
    </HashRouter>
  );
}

export default App;
